import { render, staticRenderFns } from "./Detail_Record.vue?vue&type=template&id=7bc724a1&scoped=true&"
import script from "./Detail_Record.vue?vue&type=script&lang=js&"
export * from "./Detail_Record.vue?vue&type=script&lang=js&"
import style0 from "./Detail_Record.vue?vue&type=style&index=0&id=7bc724a1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc724a1",
  null
  
)

export default component.exports